<template>
  <div>
    <section class="content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6">
            <h3>{{ $t('label.owner') }}</h3>
          </div>
          <div class="col-md-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><router-link to="/">{{ $t("label.home")}}</router-link></li>
              <li class="breadcrumb-item active">{{ $t("label.owner")}}</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
    <div class="content">
      <div class="container-fluid">

        <!-- <div class="callout callout-success">
            <br>
            <workflow-process />
        </div> -->

        <div class="card card-default">
          <div class="card-header">
            <div class="row">
              <div class="col-md-6 col-6">
                <h3 class="card-title mt-1">{{ $t("label.owner")}}</h3>
              </div>
              <div class="col-md-6 col-6 text-right">
                <router-link class="btn btn-sm btn-primary" to="/owner/create">
                  <fa :icon="fas.faPlus" /> {{ $t('label.create') }}
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-4">
                <div class="input-group">
                  <input @keyup.enter="getOwners(1)" type="text" class="form-control" autofocus v-model="search" :placeholder="$t('label.search')">
                  <div @click="getOwners(1)" class="input-group-append cursor-pointer">
                    <span class="input-group-text">
                        <fa :icon="fas.faSearch"/>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="owners.length > 0" class="table-responsive">
              <table class="table table-bordered mb-0">
                <tbody>
                <tr>
                  <th nowrap style="width: 1%;"></th>
                  <th>{{ $t('label.last_name') }}</th>
                  <th>{{ $t('label.first_name') }}</th>
                  <th>{{ $t('label.gender') }}</th>
                  <th>{{ $t('label.nationality') }}</th>
                  <th>{{ $t('label.identity_number') }}</th>
                  <th>{{ $t('label.passport_number') }}</th>
                  <th nowrap style="width: 1%;"></th>
                </tr>
                <tr v-for="(owner, index) in owners" :key="index">
                  <td>{{ index + 1}}</td>
                  <td>{{ owner.last_name }}</td>
                  <td>{{ owner.first_name }}</td>
                  <td>{{ owner.gender.toUpperCase() }}</td>
                  <td>{{ owner.nationality }}</td>
                  <td>{{ owner.identity_card_number }}</td>
                  <td>{{ owner.passport_number }}</td>
                  <td>
                    <router-link v-if="$hasPermission('tempvehicle.owner.view')" :to="{ name: 'ViewOwner', params: { id: owner.uuid }}" class="mr-1" :title="$t('label.view')">
                      <fa :icon="fas.faEye"/>
                    </router-link>
                    <router-link v-if="$hasPermission('tempvehicle.owner.edit')" :to="{ name: 'EditOwner', params: { id: owner.uuid }}" class="mr-1" :title="$t('label.edit')">
                      <fa :icon="fas.faEdit" style="color: green;"/>
                    </router-link>
                    <a v-if="$hasPermission('tempvehicle.owner.delete')" v-on:submit.prevent @click="destroy(owner)" :title="$t('label.delete')" href="javascript:void(0)">
                      <fa :icon="fas.faTrash" style="color: red;"/>
                    </a>
                  </td>
                </tr>
                </tbody>
              </table>
              <div v-if="owners.length > 0">
                <paginate class="pagination-sm mb-0"
                          :page-count="last_page"
                          :force-page="forcePage"
                          :page-range="3"
                          :margin-pages="2"
                          :click-handler="getOwners"
                          :container-class="'pagination float-right'"
                          :prev-text="'Prev'"
                          :prev-class="'page-item'"
                          :next-text="'Next'"
                          :next-class="'page-item'"
                          :page-class="'page-item'"
                          :active-class="'active'"
                          :prev-link-class="'page-link'"
                          :next-link-class="'page-link'"
                          :page-link-class="'page-link'"
                          ref="owner">
                </paginate>
              </div>
            </div>
            <div class="callout callout-success" v-else>
              <label>{{$t('label.no_data')}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fas } from "@fortawesome/free-solid-svg-icons";
export default {
  name: "Index",
  data() {
    return {
      baseURI: "",
      owners: [],
      search: '',
      forcePage: 1,
      last_page: 0,
    }
  },
  computed: {
    fas() {
      return fas;
    },
  },
  mounted() {
    this.getOwners();
  },
  methods: {
    getOwners(pageNumber = 1) {
      this.$store.state.loading.status = true;
      this.forcePage = pageNumber;
      this.forcePage = pageNumber;
      let url = this.baseURI + 'owners?page=' + pageNumber + '&per_page=' + 10;
      if(this.search){
        url = url + '&search=' + this.search;
      }
      GDCE_Client.requestApi("GET", url).then(response => {
        this.owners = response.data.data;
        this.last_page = response.data.last_page;
        this.$store.state.loading.status = false;
      });
    },
    destroy(owner) {
      this.$swal({
        title: this.$t('label.confirm_delete'),
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.loading.status = true;
          let url = this.baseURI+'/owners/'+ owner.uuid;
          GDCE_Client.requestApi("DELETE",url).then(response => {
            this.$store.state.loading.status = false;
            this.getOwners();
          }).catch(() => {
            this.$store.state.loading.status = false;
          });
        }
      });
    }
  }
}
</script>
<style scoped>
  table tbody tr td,
  table thead tr th {
    white-space: nowrap;
    word-wrap: normal;
  }
  table tbody tr td a, table tr td a {
    display: inline;
    white-space: nowrap;
    padding-left: 5px;
  }
</style>